module.exports = __webpack_public_path__ + "static/media/Compras3.fa0a777c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancCompras/Compras3.png
// module id = 2069
// module chunks = 0